import { Menu } from 'common';
import isFunction from 'lodash/isFunction';
import uniqueId from 'lodash/uniqueId';
import React from 'react';
import { FilterType } from './FilterType.enum';

const { ItemType, MenuPanel, ActionType } = Menu;

const ProductsLeftMenu = ({
	activeMenuItemId,
	categoryOptions = [],
	tagOptions = [],
	totalCount,
	onMenuItemClick,
}) => {
	const [filterBy, itemId] = activeMenuItemId.split('_');
	const isCategoryMenuActive =
		filterBy === FilterType.Category &&
		categoryOptions.some(({ CategoryID }) => CategoryID === +itemId);
	const isTagMenuActive =
		filterBy === FilterType.Tag &&
		tagOptions.some(({ OrderTagID }) => OrderTagID === +itemId);

	const menuItems = [
		{
			id: parseInt(uniqueId(), 10),
			type: ItemType.Search,
			title: 'Search Products',
			active: filterBy === FilterType.Search,
			data: {
				activeMenuItemId: FilterType.Search,
				itemName: 'Search Results',
			},
			dataqa: 'products-left-menu-search-products',
		},
		{
			id: parseInt(uniqueId(), 10),
			type: ItemType.Badge,
			title: 'All Products',
			active: filterBy === FilterType.All,
			showBadge: filterBy === FilterType.All,
			badge: totalCount || 0,
			data: {
				activeMenuItemId: FilterType.All,
				itemName: 'All Products',
			},
			dataqa: 'products-left-menu-all-products',
		},
		// WEBAPPS-27195, only show Category tab when category options exists
		categoryOptions.length > 0
			? {
					id: parseInt(uniqueId(), 10),
					type: ItemType.Group,
					title: 'Category',
					active: isCategoryMenuActive,
					collapsed: !isCategoryMenuActive,
					items: categoryOptions.map(option => ({
						id: parseInt(uniqueId(), 10),
						type: ItemType.Badge,
						title: option.Name,
						active: option.CategoryID === +itemId,
						showBadge: option.CategoryID === +itemId,
						badge: option.ProductCount,
						data: {
							activeMenuItemId: `${FilterType.Category}_${option.CategoryID}`,
							itemName: option.Name,
						},
						dataqa: 'products-left-menu-category',
					})),
				}
			: null,
		// WEBAPPS-27195, only show Tags tab when tag options exists
		tagOptions.length > 0
			? {
					id: parseInt(uniqueId(), 10),
					type: ItemType.Group,
					title: 'Tags',
					active: isTagMenuActive,
					collapsed: !isTagMenuActive,
					items: tagOptions.map(option => ({
						id: parseInt(uniqueId(), 10),
						type: ItemType.Badge,
						title: option.Tag,
						active: option.OrderTagID === +itemId,
						showBadge: option.OrderTagID === +itemId,
						showTag: true,
						tagColor: option.Color,
						badge: isTagMenuActive ? totalCount : 0,
						data: {
							activeMenuItemId: `${FilterType.Tag}_${option.OrderTagID}`,
							itemName: option.Tag,
						},
						dataqa: 'products-left-menu-tags',
					})),
				}
			: null,
	].filter(item => item !== null);

	const onActionTrigger = (actionType, itemType, data) => {
		if (isFunction(onMenuItemClick)) {
			const menuItemData = {
				activeMenuItemId: data.activeMenuItemId,
				leftMenuTitle: data.itemName,
				term: data.term || '',
			};

			if (
				activeMenuItemId === FilterType.Search &&
				actionType === ActionType.Delete
			) {
				// clicking "X" or empty "term" value should switch to filter by "All"
				menuItemData.activeMenuItemId = FilterType.All;
				menuItemData.leftMenuTitle = 'All Products';
			}

			onMenuItemClick(menuItemData);
		}
	};

	return (
		<MenuPanel
			items={menuItems}
			onActionTrigger={onActionTrigger}
			placeholder="Search Products"
			showResult={activeMenuItemId === FilterType.Search}
			resultCount={totalCount}
		/>
	);
};

export default ProductsLeftMenu;
